import React from "react";
var __jsx = React.createElement;
import stl from "./SubmitButton.module.css";
var SubmitButton = function SubmitButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    className = _ref.className,
    type = _ref.type,
    loading = _ref.loading,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("button", {
    className: "".concat(stl.btn, " ").concat(className ? className : "", " ").concat(disabled ? stl.disabled : ""),
    onClick: onClick,
    type: type ? type : null,
    disabled: disabled
  }, loading ? /*#__PURE__*/React.createElement("span", {
    className: stl.loader
  }) : children);
};
export default SubmitButton;